<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <CInput
                    placeholder="user@example.com"
                    autocomplete="email"
                    v-model="data.email"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-user"
                    /></template>
                  </CInput>
                  <CInput
                    placeholder="Password"
                    type="password"
                    autocomplete="curent-password"
                    v-model="data.password"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-lock-locked"
                    /></template>
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton
                        color="primary"
                        class="px-4"
                        v-on:click="login(data)"
                        >Login</CButton
                      >
                    </CCol>
                    <CCol col="6" class="text-right">
                      <CButton color="link" class="px-0" href="/#/pages/forgot"
                        >Forgot password?</CButton
                      >
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
    <Enter2FAModal
      :key="verificationStep"
      :showModal="isShowVerify2FAModal"
      :title="verificationModalTitle"
      :label="verificationModalLabel"
      @close-modal="closeVerificationModal"
      @2fa-verify-code="onVerify2FA"
    />
  </div>
</template>

<script>
import { ACTION_LOGIN, ACTION_FETCH_PROFILE } from '@/store/actions.type';
import { MUTATION_SET_AUTH } from '@/store/mutations.type';

import Enter2FAModal from '@/components/modals/Enter2FAModal';
import UserInternalProxy from '@/proxies/userinternal.proxy';

export default {
  name: 'Login',
  components: {
    Enter2FAModal,
  },
  data() {
    return {
      loading: false,
      data: {
        email: '',
        password: '',
      },
      isShowVerify2FAModal: false,
      verificationStep: '',
      token: '',
    };
  },
  computed: {
    verificationModalTitle() {
      return this.verificationStep === 'sms' ? 'Verify SMS' : 'Verify 2FA';
    },
    verificationModalLabel() {
      return this.verificationStep === 'sms'
        ? 'Enter SMS code'
        : 'Enter 2FA code';
    },
  },
  methods: {
    login(data) {
      return this.$store
        .dispatch(ACTION_LOGIN, data)
        .then((res) => this.handleLoginResponse(res))
        .catch((err) => {
          if (this.$toast) {
            const message = err?.response?.data?.message || 'Login failed';
            this.$toast.error(message);
          }
        });
    },
    handleLoginResponse(res) {
      if (res.otp_required) {
        this.verificationStep = 'sms';
        this.isShowVerify2FAModal = true;
        return;
      }
      if (res.two_factor_enabled) {
        this.token = res.token;
        this.verificationStep = 'authenticator';
        this.isShowVerify2FAModal = true;
        return;
      }
      return this.completeLogin();
    },
    completeLogin() {
      this.isShowVerify2FAModal = false;
      this.verificationStep = '';
      return this.$store.dispatch(ACTION_FETCH_PROFILE).then(() => {
        this.$router.push({ name: 'dashboard.index' });
      });
    },
    onVerify2FA({ code }) {
      if (this.verificationStep === 'sms') {
        return this.$store
          .dispatch(ACTION_LOGIN, { ...this.data, code })
          .then((res) => this.handleLoginResponse(res))
          .catch((err) => {
            if (this.$toast) {
              const message =
                err?.response?.data?.message || 'Verification failed';
              this.$toast.error(message);
            }
          });
      }
      return UserInternalProxy.verify2FA(this.token, { code })
        .then(() => {
          this.$store.commit(MUTATION_SET_AUTH, this.token);
          this.$toast.success(`Verify 2FA successfully`, {
            duration: 5000,
          });
          return this.completeLogin();
        })
        .catch((err) => {
          if (this.$toast) {
            const message =
              err?.response?.data?.message || 'Verify 2FA failed';
            this.$toast.error(message);
          }
        });
    },
    closeVerificationModal() {
      this.isShowVerify2FAModal = false;
      this.verificationStep = '';
    },
  },
};
</script>
